var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.229,
    height: 22.229,
    viewBox: "0 0 22.229 22.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "united-kingdom",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(0.114 0.114)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(0.383 0.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M10.734,100.142a11.074,11.074,0,0,0-1.915,3.867H14.6Z",
    transform: "translate(-8.819 -96.177)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M375.787,104.01a11.074,11.074,0,0,0-1.915-3.867l-3.867,3.867Z",
    transform: "translate(-354.324 -96.178)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M8.819,322.784a11.075,11.075,0,0,0,1.915,3.867l3.867-3.867Z",
    transform: "translate(-8.819 -309.153)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M326.649,10.734a11.075,11.075,0,0,0-3.867-1.915V14.6Z",
    transform: "translate(-309.151 -8.819)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M100.142,373.872a11.075,11.075,0,0,0,3.867,1.915v-5.782Z",
    transform: "translate(-96.177 -354.324)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M104.009,8.819a11.075,11.075,0,0,0-3.867,1.915l3.867,3.867Z",
    transform: "translate(-96.177 -8.819)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M322.783,375.787a11.074,11.074,0,0,0,3.867-1.915l-3.867-3.867Z",
    transform: "translate(-309.152 -354.324)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M370.005,322.784l3.867,3.867a11.075,11.075,0,0,0,1.915-3.867Z",
    transform: "translate(-354.324 -309.153)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M22.134,9.665h-9.57V.094a11.216,11.216,0,0,0-2.9,0v9.57H.094a11.216,11.216,0,0,0,0,2.9h9.57v9.571a11.216,11.216,0,0,0,2.9,0v-9.57h9.571a11.216,11.216,0,0,0,0-2.9Z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M322.783,322.783h0l4.96,4.96q.342-.342.653-.714l-4.246-4.246h-1.367Z",
    transform: "translate(-308.769 -308.769)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M79.94,322.784h0l-4.96,4.96q.342.342.714.653l4.246-4.246Z",
    transform: "translate(-71.725 -308.77)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M65.546,79.94h0l-4.96-4.96q-.342.342-.653.714l4.246,4.246h1.367Z",
    transform: "translate(-57.331 -71.725)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M322.783,65.547h0l4.96-4.96q-.342-.342-.714-.653l-4.246,4.246Z",
    transform: "translate(-308.769 -57.332)",
    fill: "#d80027"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.1aeed85631c41321feda04153bd8b696.svg";
export { ForwardRef as ReactComponent };